

import React, { useState, useEffect } from 'react';
import { Offcanvas, Button, Row, Col, Badge } from 'react-bootstrap';
import axios from 'axios';
import { FaFilePdf, FaDownload, FaPrint, FaEye, FaEdit } from 'react-icons/fa';

// const QuotationPreviewModal = ({
//     showModal,
//     handleClose,
//     onEdit,
//     onDownload,
//     clientName,
//     projectName,
//     clientCurrency,
//     brands,
//     categories,
//     selectedProducts = [],
//     customIntegrationDescription = "",
//     customIntegrationTotal = 0,
//     formData,editableDeploymentDescriptions=''
// }) => {
//     console.log('🎯 QuotationPreviewModal rendered with showModal:', showModal);
//     console.log('product', selectedProducts);
//     console.log('formData', formData);
//      console.log('🎯 QuotationPreviewModal rendered with deployment descriptions:', editableDeploymentDescriptions);
//     const [products, setProducts] = useState([]); 
//         const [companyDetails, setCompanyDetails] = useState(null);

//      const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//     const origin = localStorage.getItem('user-origin');
//     const token = userInfo?.token;
//  const fetchProducts = async () => {
//         try {
//             const response = await axios.get(`${backendUrl}/api/products`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });
//             setProducts(response.data.Data);
//         } catch (error) {
//             console.error('Error fetching products:', error);
//         }
//     };
//        const fetchCompanyDetails = async () => {
//         try {
//             const response = await axios.get(`${backendUrl}/api/settings`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             setCompanyDetails(response.data.setting);
//         } catch (error) {
//             console.error('Error fetching company details:', error);
//         }
//     };

//    useEffect(() => {
//         fetchProducts();
//         fetchCompanyDetails();

//     }, []);

//     // Safe number formatting
//     const safeToFixed = (value, decimals = 2) => {
//         if (value === null || value === undefined) return '0.00';
//         const num = parseFloat(value);
//         return isNaN(num) ? '0.00' : num.toFixed(decimals);
//     };
//     const [editableDeploymentAmount, setEditableDeploymentAmount] = useState(0);

//     // ✅ Product categorization (same as renderStep4)
//     const getLicenseProducts = () => {
//         const licenseProducts = selectedProducts.filter(product => {
//             try {
//                 const productData = product.pricings || product;
//                 const isLicenseType =
//                     productData.categories?.some(cat =>
//                         cat.licence_type?.toLowerCase() === 'license'
//                     ) ||
//                     productData.licence_type?.toLowerCase() === 'license' ||
//                     product.revenue_type === 'perpetual' ||
//                     (!productData.categories && !productData.licence_type);
//                 return isLicenseType;
//             } catch (error) {
//                 console.error('Error checking product type:', error, product);
//                 return true;
//             }
//         });
//         return licenseProducts;
//     };


//     const getDefaultServices = () => {
//         if (formData.model_type !== "new") {
//             return [];
//         }

//         return products.filter(product => {
//             // const isDefaultChannel = product.is_default_channel === true;
//             const isServiceLicenseType = product.license_type?.toLowerCase() === "service";

//             return isServiceLicenseType;
//         });
//     };


//     const defaultServices = getDefaultServices();



//     // const calculateDeploymentConfigurationAmount = () => {
//     //     if (formData.model_type !== "new") return 0;

//     //     const amount = defaultServices.reduce((total, service) => {
//     //         let price = 0;
//     //         if (Array.isArray(service.pricings) && service.pricings.length > 0) {
//     //             price = service.pricings[0].price || service.pricings[0].amount || 0;
//     //         }
//     //         return total + parseFloat(price);
//     //     }, 0);

//     //     return parseFloat(convertPrice(amount));
//     // };

//     // ✅ Initialize editable amount when default services change
//     const calculateDeploymentConfigurationAmount = () => {
//         if (formData.model_type !== "new") return 0;

//         const selectedLicenseTypeId = formData.license_type_id;

//         // Find selected license model name (like "subscription", "perpetual", etc.)
//         const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
//             (c) => String(c.id) === String(selectedLicenseTypeId)
//         );
//         const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

//         // Loop over all default service-type products
//         const amount = defaultServices.reduce((total, service) => {
//             // Only count service products
//             if (service.license_type?.toLowerCase() !== "service") return total;

//             let price = 0;

//             // ✅ Match pricing array based on license model
//             if (Array.isArray(service.pricings) && service.pricings.length > 0) {
//                 const matchingPricing = service.pricings.find(
//                     (p) => p.license_model?.toLowerCase() === selectedLicenseModel
//                 );

//                 if (matchingPricing) {
//                     price = Number(matchingPricing.price || matchingPricing.amount || 0);
//                 } else {
//                     // ✅ fallback: if no matching license_model found, take 0
//                     price = 0;
//                 }
//             }

//             return total + price;
//         }, 0);

//         return parseFloat(amount);
//     };


//     useEffect(() => {
//         if (formData.model_type === "new" && defaultServices.length > 0) {
//             setEditableDeploymentAmount(prev => {
//                 if (prev === 0 || prev === "" || isNaN(prev)) {
//                     return calculateDeploymentConfigurationAmount();
//                 }
//                 return prev; // keep user-edited value
//             });
//         }
//     }, [defaultServices, formData.model_type]);
//     const getProductDeploymentCost = (productItem) => {
//         const selectedLicenseName =
//             formData?.license_type_name?.toLowerCase?.() ||
//             categories?.allCategoriesList?.find(
//                 (c) => String(c.id) === String(formData?.license_type_id)
//             )?.name?.toLowerCase?.() ||
//             null;

//         // Safely access nested product.pricings
//         const pricings = productItem?.product?.pricings || [];

//         if (!Array.isArray(pricings) || pricings.length === 0) {
//             return parseFloat(productItem?.product?.deployment_cost || 0);
//         }

//         const matchedPricing =
//             pricings.find(
//                 (p) => p.license_model?.toLowerCase() === selectedLicenseName
//             ) ||
//             pricings.find((p) => parseFloat(p.deployment_cost) > 0) ||
//             pricings[0];

//         console.log("🧩 Matched pricing for", productItem.item_name, matchedPricing);

//         return parseFloat(matchedPricing?.deployment_cost || 0);
//     };



//     const getProductDeploymentDescription = (productItem) => {
//         const selectedLicenseId = formData?.license_type_id;
//         const selectedLicenseObj = categories?.allCategoriesList?.find(
//             (c) => String(c.id) === String(selectedLicenseId)
//         );
//         const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

//         // Access nested product.pricings
//         const pricings = productItem?.product?.pricings || [];

//         // Debug check
//         console.log("🧠 Selected license:", selectedLicenseName);
//         console.log("🧩 Available pricings:", pricings);

//         if (!Array.isArray(pricings) || pricings.length === 0) {
//             return `${productItem.item_name} Setup`;
//         }

//         const matchedPricing = selectedLicenseName
//             ? pricings.find(
//                 (p) => p.license_model?.toLowerCase?.() === selectedLicenseName
//             )
//             : pricings[0];

//         return (
//             matchedPricing?.deployment_description ||
//             `${productItem.item_name} Deployment & Configuration`
//         );
//     };


//     // ✅ Calculate One Time Total (sum of all product deployment costs)
//     const calculateOneTimeTotal = () => {
//         return selectedProducts.reduce((total, product) => {
//             const deploymentCost = getProductDeploymentCost(product);
//             return total + deploymentCost;
//         }, 0);
//     };




//     // ✅ Get all deployment items (EXACTLY like renderStep4)
//     const getAllDeploymentItems = () => {
//         const items = [];

//         // Add individual product deployments FROM PRICING DATA
//         selectedProducts.forEach(product => {
//             const deploymentCost = getProductDeploymentCost(product);
//             if (deploymentCost > 0) {
//                 // const description = getProductDeploymentDescription(product);
//                 // items.push(description);
//                  const description = editableDeploymentDescriptions[product.product_id] || 
//                                   product.deployment_description ||
//                                   getProductDeploymentDescription(product) ||
//                                   `${product.item_name} Deployment & Configuration`;
//                 items.push(description);
//             }
//         });

//         // Add custom integration items
//         if (customIntegrationDescription) {
//             const tempDiv = document.createElement('div');
//             tempDiv.innerHTML = customIntegrationDescription;

//             const listItems = tempDiv.querySelectorAll('li, p, div');

//             if (listItems.length > 0) {
//                 listItems.forEach(item => {
//                     const text = item.textContent?.trim();
//                     if (text && text.length > 0) {
//                         items.push(text);
//                     }
//                 });
//             } else {
//                 const lines = customIntegrationDescription.split(/<br\s*\/?>|<\/p>|<\/div>|\n|\•|\-/);
//                 lines.forEach(line => {
//                     const text = line.replace(/<[^>]*>/g, '').trim();
//                     if (text && text.length > 0) {
//                         items.push(text);
//                     }
//                 });
//             }
//         }

//         return items;
//     };
//     const usdToAedExchangeRate = 3.67;
//     // ✅ Calculate totals (EXACTLY like renderStep4)
//     const calculateTotals = () => {
//         const licenseProducts = getLicenseProducts();

//         const licenseTotal = licenseProducts.reduce((total, product) =>
//             total + parseFloat(product.subtotal || 0), 0
//         );



//         const oneTimeTotal = calculateOneTimeTotal();
//         // const editableDeploymentAmount = getEditableDeploymentAmount();

//         const convertedIndividualDeploymentAmount = clientCurrency === 'USD'
//             ? oneTimeTotal / usdToAedExchangeRate
//             : oneTimeTotal;
//         const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);
//         const subscriptionPeriod = parseInt(formData?.subscription_period || 12);

//         const selectedLicenseId = formData?.license_type_id;
//         const selectedLicenseObj = categories?.allCategoriesList?.find(
//             (c) => String(c.id) === String(selectedLicenseId)
//         );
//         const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

//         let totalLicenseCost = licenseTotal;
//         if (selectedLicenseName === 'subscription') {
//             totalLicenseCost = licenseTotal * subscriptionPeriod;
//         }

//         // ✅ CRITICAL: Same calculation as renderStep4
//         const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;
//         const subtotal = totalLicenseCost + totalOneTimeCost;

//         // Calculate discount
//         let discountAmount = 0;
//         if (formData?.discount_amount > 0) {
//             if (formData.discount_type === 'percentage') {
//                 discountAmount = (parseFloat(formData.discount_amount) / 100) * subtotal;
//             } else {
//                 discountAmount = parseFloat(formData.discount_amount);
//             }
//         }

//         const grandTotal = subtotal - discountAmount;

//         return {
//             licenseProducts,
//             licenseTotal,
//             oneTimeTotal,
//             editableDeploymentAmount,
//             convertedIndividualDeploymentAmount,
//             customIntegrationTotal: customIntegrationTotalValue,
//             subscriptionPeriod,
//             selectedLicenseName,
//             totalLicenseCost,
//             totalOneTimeCost,
//             subtotal,
//             discountAmount,
//             grandTotal
//         };
//     };

//     const totals = calculateTotals();
//     const allDeploymentItems = getAllDeploymentItems();
//     const selectedBrand = brands?.find(b => b.id === Number(formData?.brand_id))?.name || "Brand";

//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '900px' }} className="quotation-preview-offcanvas">
//             <Offcanvas.Header closeButton className="border-bottom bg-light">
//                 <Offcanvas.Title className="fw-semibold">
//                     <i className="fa fa-file-pdf text-danger me-2"></i>
//                     Quotation Preview - {formData?.ref_no}
//                 </Offcanvas.Title>
//             </Offcanvas.Header>

//             <Offcanvas.Body style={{
//                 padding: '0',
//                 backgroundColor: '#f8f9fa'
//             }}>
//                 {/* PDF Style Preview */}
//                 <div style={{
//                     padding: '20px',
//                     backgroundColor: 'white',
//                     minHeight: '100%',
//                     width: '210mm',
//                     margin: '0 auto',
//                     fontSize: '12px'
//                 }}>
//                     {/* NEW HEADER - Matching HTML Template */}
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         position: 'relative',
//                         marginBottom: '10px'
//                     }}>
//                         {/* Left Section - Company Details */}
//                         <div style={{ display: 'flex', flexDirection: 'column' }}>
//                             <div style={{ 
//                                 fontSize: '18px', 
//                                 fontWeight: 'bold', 
//                                 marginBottom: '6px' 
//                             }}>
//                                 {companyDetails?.company_name || 'SYSTECH TECHNOLOGIES'}
//                             </div>
//                             <div style={{ 
//                                 fontSize: '12px', 
//                                 lineHeight: '1.5' 
//                             }}>
//                                 {companyDetails?.company_address ? (
//                                     <div dangerouslySetInnerHTML={{ 
//                                         __html: companyDetails.company_address 
//                                     }} />
//                                 ) : (
//                                     <>
//                                         Dirt All Nokia Building, Office 307<br />
//                                         P.O Box 91507
//                                     </>
//                                 )}
//                                 <br />
//                                 Phone: {companyDetails?.phone || 'N/A'}<br />
//                                 Email: {companyDetails?.email || 'N/A'}
//                             </div>
//                         </div>

//                         {/* Right Section - Logo and Quotation Title */}
//                         <div style={{ 
//                             display: 'flex', 
//                             flexDirection: 'column', 
//                             alignItems: 'flex-end',
//                             position: 'absolute',
//                             right: '0',
//                             top: '0'
//                         }}>
//                             {/* Logo - You'll need to replace this with your actual logo logic */}
//                             <div style={{
//                                 width: '180px',
//                                 height: '80px',
//                                 // backgroundColor: '#f0f0f0',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 // border: '1px solid #ddd',
//                                 // marginBottom: '8px'
//                             }}>
//                                 {companyDetails?.logo ? (
//                                     <img 
//                                         src={`${backendUrl}/storage/${companyDetails.logo}`} 
//                                         alt="Company Logo" 
//                                         style={{ 
//                                             maxWidth: '100%', 
//                                             maxHeight: '100%',
//                                             objectFit: 'contain' 
//                                         }}
//                                     />
//                                 ) : (
//                                     <span style={{ color: '#666', fontSize: '11px' }}>Company Logo</span>
//                                 )}
//                             </div>
//                             <div style={{ 
//                                 fontSize: '24px', 
//                                 fontWeight: 'bold', 
//                                 color: 'black',
//                                 // marginTop: '12px'
//                             }}>
//                                 QUOTATION
//                             </div>
//                         </div>
//                     </div>

//                     {/* Divider */}
//                     <div style={{ 
//                         borderTop: '1px solid #ddd', 
//                         margin: '10px 0 20px 0' 
//                     }}></div>

//                     {/* Quotation Details */}
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         marginBottom: '20px',
//                         width: '100%'
//                     }}>
//                         {/* Left Column - Project Info */}
//                         <div style={{ 
//                             float: 'left', 
//                             width: '48%', 
//                             boxSizing: 'border-box' 
//                         }}>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Project</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>{projectName || 'INSP-WPP'}</span>
//                             </div>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Document No</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>{formData?.ref_no || 'Q25-AE/01/2049'}</span>
//                             </div>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Date</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>{formData?.date || '01 Jul 2025'}</span>
//                             </div>
//                         </div>

//                         {/* Right Column - Customer Info */}
//                         <div style={{ 
//                             float: 'right', 
//                             width: '48%', 
//                             boxSizing: 'border-box' 
//                         }}>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Customer:</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>{clientName || 'Customer Name'}</span>
//                             </div>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Address:</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>
//                                     {/* You might want to add client address logic here */}
//                                     {clientName ? `${clientName} Address` : 'Customer Address'}
//                                 </span>
//                             </div>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Email:</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>
//                                     {/* You might want to add client email logic here */}
//                                     {clientName ? `${clientName.toLowerCase().replace(' ', '')}@example.com` : 'customer@example.com'}
//                                 </span>
//                             </div>
//                             <div style={{ marginBottom: '8px' }}>
//                                 <span style={{ 
//                                     display: 'inline-block', 
//                                     width: '100px', 
//                                     fontWeight: 'bold',
//                                     verticalAlign: 'top',
//                                     whiteSpace: 'nowrap'
//                                 }}>Phone:</span>
//                                 <span style={{ 
//                                     display: 'inline-block',
//                                     marginLeft: '8px',
//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'normal',
//                                     lineHeight: '1.5',
//                                     maxWidth: 'calc(100% - 180px)',
//                                     verticalAlign: 'top'
//                                 }}>
//                                     {/* You might want to add client phone logic here */}
//                                     {clientName ? '+971-XXXXXXX' : '+971-66838999'}
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                     {/* ============================= LICENSE SECTION (Same as renderStep4) ============================= */}
//                     {totals.licenseProducts.length > 0 && (
//                         <div className="mb-4 border rounded">
//                             <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
//                                 {selectedBrand} - Licenses
//                             </div>

//                             <div className="table-responsive">
//                                 <table className="table table-bordered mb-0 align-middle">
//                                     <thead>
//                                         <tr>
//                                             <th style={{ width: "20%", fontSize: "12px", fontWeight: "bold" }}>Product</th>
//                                             <th style={{ width: "40%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
//                                             <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Qty</th>
//                                             <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Unit Price ({clientCurrency})</th>
//                                             <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Total ({clientCurrency})</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {totals.licenseProducts.map((product, index) => (
//                                             <tr key={index}>
//                                                 <td style={{ fontSize: "12px" }}>
//                                                     {product.item_name}
//                                                 </td>
//                                                 <td style={{ fontSize: "12px" }} className="text-start">{product.item_description || '-'}</td>
//                                                 <td style={{ fontSize: "12px" }} className="text-center">{product.quantity || 1}</td>
//                                                 <td style={{ fontSize: "12px" }} className="text-center">
//                                                     {safeToFixed(product.price)}
//                                                 </td>
//                                                 <td style={{ fontSize: "12px" }} className="text-end">
//                                                     {safeToFixed(product.subtotal)}
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                     <tfoot>
//                                         <tr>
//                                             <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
//                                                 Total License Cost {totals.selectedLicenseName === 'subscription' ? 'per month' : ''}
//                                             </td>
//                                             <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
//                                                 {safeToFixed(totals.licenseTotal)}
//                                             </td>
//                                         </tr>
//                                         {totals.selectedLicenseName === 'subscription' && (
//                                             <tr>
//                                                 <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
//                                                     Total License Cost per {totals.subscriptionPeriod} months
//                                                 </td>
//                                                 <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
//                                                     {safeToFixed(totals.totalLicenseCost)}
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tfoot>
//                                 </table>
//                             </div>
//                         </div>
//                     )}

//                     {/* ============================= ONE-TIME & INTEGRATION SECTION (EXACTLY like renderStep4) ============================= */}
//                     {( totals.editableDeploymentAmount > 0 || (totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal) > 0) && (
//                         <div className="mb-4 border rounded">
//                             <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
//                                 {selectedBrand} - Onboarding & Custom Integration
//                             </div>

//                             <div className="table-responsive">
//                                 <table className="table table-bordered mb-0 align-middle">
//                                     <thead>
//                                         <tr>
//                                             <th style={{ width: "65%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
//                                             <th style={{ width: "5%", fontSize: "12px", fontWeight: "bold" }}>QTY</th>
//                                             <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Price ({clientCurrency})</th>
//                                             <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Total ({clientCurrency})</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>


//                                         {/* ✅ One Time deployment, Configuration & Testing - Separate Row - Same as renderStep4 */}
//                                         {totals.editableDeploymentAmount > 0 && (
//                                             <tr>
//                                                 <td style={{ fontSize: "13px" }} className='text-start'>
//                                                     One Time deployment, Configuration & Testing
//                                                 </td>
//                                                 <td className="text-center" style={{ fontSize: "12px" }}>1</td>
//                                                 <td className="text-center" style={{ fontSize: "12px" }}>
//                                                     {safeToFixed(totals.editableDeploymentAmount)}
//                                                 </td>
//                                                 <td className="text-end" style={{ fontSize: "12px" }}>
//                                                     {safeToFixed(totals.editableDeploymentAmount)}
//                                                 </td>
//                                             </tr>
//                                         )}

//                                         {/* ✅ Custom Integration with Ordered List - EXACTLY like renderStep4 */}
//                                         {(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal) > 0 && (
//                                             <tr>
//                                                 <td className="text-start" style={{ fontSize: "13px" }}>
//                                                     <div className="fw-medium">Custom Integration</div>
//                                                     {allDeploymentItems.length > 0 && (
//                                                         <div className="mt-2">
//                                                             <ol className="mb-0" style={{ fontSize: "12px", paddingLeft: "20px" }}>
//                                                                 {allDeploymentItems.map((item, index) => (
//                                                                     <li key={index} className="text-muted">
//                                                                         {item}
//                                                                     </li>
//                                                                 ))}
//                                                             </ol>
//                                                         </div>
//                                                     )}
//                                                 </td>
//                                                 <td className='text-center' style={{ fontSize: "12px" }}>1</td>
//                                                 <td className="text-center" style={{ fontSize: "12px" }}>
//                                                     {safeToFixed(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal)}
//                                                 </td>
//                                                 <td className="text-end" style={{ fontSize: "12px" }}>
//                                                     {safeToFixed(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal)}
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                     <tfoot>
//                                         <tr>
//                                             <td colSpan="3" className="text-end fw-medium" style={{ fontSize: "13px" }}>
//                                                 Total One-time Cost ({clientCurrency})
//                                             </td>
//                                             <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
//                                                 {safeToFixed(totals.totalOneTimeCost)}
//                                             </td>
//                                         </tr>
//                                     </tfoot>
//                                 </table>
//                             </div>
//                         </div>
//                     )}

//                     {/* Debug Section */}
//                     {/* {process.env.NODE_ENV === 'development' && (
//                         <div className="mt-3 p-3 border rounded bg-warning bg-opacity-10">
//                             <h6 className="fw-bold">Debug Info</h6>
//                             <div style={{ fontSize: '11px' }}>
//                                 <p>Total Products: {selectedProducts.length}</p>
//                                 <p>License Products: {totals.licenseProducts.length}</p>
//                                 <p>Service Products: {totals.serviceProducts.length}</p>
//                                 <p>Editable Deployment Amount: {totals.editableDeploymentAmount}</p>
//                                 <p>Individual Deployment Amount: {totals.convertedIndividualDeploymentAmount}</p>
//                                 <p>Custom Integration Total: {totals.customIntegrationTotal}</p>
//                                 <p>Deployment Items: {allDeploymentItems.length}</p>
//                                 <p>All Deployment Items: {JSON.stringify(allDeploymentItems)}</p>
//                                 <p>Product Pricing Data: {JSON.stringify(selectedProducts.map(p => ({
//                                     name: p.item_name,
//                                     deployment_cost: getProductDeploymentCost(p),
//                                     deployment_description: getProductDeploymentDescription(p),
//                                     pricings: p.pricings
//                                 })))}</p>
//                             </div>
//                         </div>
//                     )} */}

//                     {/* Terms & Conditions */}
//                     {formData?.notes && (
//                         <div className="mt-4 pt-3 border-top">
//                             <h6 className="fw-bold border-bottom pb-2">Terms & Conditions</h6>
//                             <div
//                                 style={{ fontSize: "12px" }}
//                                 dangerouslySetInnerHTML={{ __html: formData.notes }}
//                             />
//                         </div>
//                     )}
//                 </div>
//             </Offcanvas.Body>

//             <div className="p-3 border-top bg-light d-flex justify-content-between">
//                 <Button
//                     variant="outline-secondary"
//                     onClick={handleClose}
//                     size="sm"
//                 >
//                     <i className="fa fa-times me-2"></i>
//                     Close
//                 </Button>
//                 <div>
//                     <Button
//                         variant="warning"
//                         onClick={onEdit}
//                         size="sm"
//                         className="me-2"
//                     >
//                         <i className="fa fa-edit me-2"></i>
//                         Edit Quotation
//                     </Button>
//                     <Button
//                         variant="primary"
//                         onClick={onDownload}
//                         size="sm"
//                     >
//                         <i className="fa fa-download me-2"></i>
//                         Download PDF
//                     </Button>
//                 </div>
//             </div>
//         </Offcanvas>
//     );
// };
const QuotationPreviewModal = ({
    showModal,
    handleClose,
    onEdit,
    onDownload,
    clientName,
    projectName,
    clientCurrency,
    brands,
    categories,
    selectedProducts = [],
    customIntegrationDescription = "",
    customIntegrationTotal = 0,
    formData,
    editableDeploymentDescriptions = '',
    isUploaded = false,
    uploadedFileUrl = null
}) => {
    console.log('🎯 QuotationPreviewModal rendered with showModal:', showModal);
    console.log('product', selectedProducts);
    console.log('formData', formData);
    console.log('🎯 QuotationPreviewModal rendered with deployment descriptions:', editableDeploymentDescriptions);

    const [products, setProducts] = useState([]);
    const [companyDetails, setCompanyDetails] = useState(null);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    const origin = localStorage.getItem('user-origin');
    const token = userInfo?.token;

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/products`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setProducts(response.data.Data);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchCompanyDetails = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setCompanyDetails(response.data.setting);
        } catch (error) {
            console.error('Error fetching company details:', error);
        }
    };

    // useEffect(() => {
    //     fetchProducts();
    //     fetchCompanyDetails();
    // }, []);

    useEffect(() => {
        if (!isUploaded) {
            // Only fetch products for system-generated quotations
            fetchProducts();
        }
        fetchCompanyDetails();
    }, [isUploaded]);

    // Safe number formatting
    const safeToFixed = (value, decimals = 2) => {
        if (value === null || value === undefined) return '0.00';
        const num = parseFloat(value);
        return isNaN(num) ? '0.00' : num.toFixed(decimals);
    };


    // Construct proper document URL - always returns an absolute URL
    const getFullDocumentUrl = () => {
        if (!uploadedFileUrl) return null;

        // If it's already a full URL, return as is
        if (uploadedFileUrl.startsWith('http')) {
            return uploadedFileUrl;
        }

        // Always build a full absolute URL using backendUrl
        const base = backendUrl.replace(/\/$/, ''); // strip trailing slash
        const path = uploadedFileUrl.replace(/^\//, '').replace(/^storage\//, '');
        return `${base}/storage/${path}`;
    };

    const fullDocumentUrl = getFullDocumentUrl();

    // const handleDocumentDownload = () => {
    //     if (fullDocumentUrl) {
    //         const link = document.createElement('a');
    //         link.href = fullDocumentUrl;
    //         link.download = `quotation-${formData?.ref_no || 'document'}.pdf`;
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //     }
    // };


    const handleDocumentDownload = async () => {
        if (!formData?.id) return;

        const safeRefNo = formData.ref_no?.replace(/[\/\\]/g, "-") || "quotation";

        const response = await axios.get(
            `${backendUrl}/api/quotations/${formData.id}/download`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
                responseType: "blob",
            }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = `quotation-${safeRefNo}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renderUploadedDocumentPreview = () => {
        // Detect file type from URL
        const fileExtension = fullDocumentUrl?.split('.').pop()?.toLowerCase().split('?')[0];
        const isPdf = fileExtension === 'pdf';
        const isWord = ['doc', 'docx'].includes(fileExtension);
        const isExcel = ['xls', 'xlsx'].includes(fileExtension);

        // Build absolute Office Online viewer URL for Word/Excel docs
        // Note: Office Online viewer requires a publicly accessible URL
        const absoluteDocUrl = fullDocumentUrl || '';
        const officeViewerUrl = absoluteDocUrl
            ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(absoluteDocUrl)}`
            : null;

        // Google Docs viewer as fallback (also needs public URL)
        const googleViewerUrl = absoluteDocUrl
            ? `https://docs.google.com/gview?url=${encodeURIComponent(absoluteDocUrl)}&embedded=true`
            : null;

        return (
            <div style={{
                padding: '20px',
                backgroundColor: 'white',
                minHeight: '100%',
                width: '100%',
                margin: '0 auto',
                fontSize: '12px'
            }}>
                {/* Document Section */}
                <div className="mb-4">
                    <div className="p-0">
                        {fullDocumentUrl ? (
                            <div>
                                {isPdf ? (
                                    /* PDF: native browser viewer */
                                    <div style={{ height: '1050px', width: '100%', overflow: 'hidden' }}>
                                        <iframe
                                            src={`${fullDocumentUrl}#toolbar=0&navpanes=0`}
                                            width="100%"
                                            height="100%"
                                            style={{ border: 'none', display: 'block' }}
                                            title={`Quotation Document - ${formData?.ref_no}`}
                                            frameBorder="0"
                                        />
                                    </div>
                                ) : (isWord || isExcel) ? (
                                    /* Word/Excel: Microsoft Office Online Viewer */
                                    <div>
                                        <div style={{
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '8px',
                                            padding: '10px 14px',
                                            marginBottom: '10px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            border: '1px solid #dee2e6'
                                        }}>
                                            <span style={{ fontSize: '22px' }}>
                                                {isWord ? '📄' : '📊'}
                                            </span>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: 600, fontSize: '13px' }}>
                                                    {isWord ? 'Word Document' : 'Excel Spreadsheet'}
                                                </div>
                                                <div style={{ color: '#6c757d', fontSize: '11px' }}>
                                                    Previewing via Microsoft Office Online
                                                </div>
                                            </div>
                                            <a
                                                href={fullDocumentUrl}
                                                download
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-sm btn-outline-primary"
                                                style={{ fontSize: '12px' }}
                                            >
                                                ⬇ Download
                                            </a>
                                        </div>
                                        <div style={{ height: '1000px', width: '100%', overflow: 'hidden' }}>
                                            <iframe
                                                src={officeViewerUrl}
                                                width="100%"
                                                height="100%"
                                                style={{ border: 'none', display: 'block' }}
                                                title={`Quotation Document - ${formData?.ref_no}`}
                                                frameBorder="0"
                                                onError={(e) => {
                                                    // Fallback to Google Docs viewer
                                                    e.target.src = googleViewerUrl;
                                                }}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    /* Other file types: show download link */
                                    <div className="text-center py-5">
                                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📎</div>
                                        <h5 className="mb-2">Preview Not Available</h5>
                                        <p className="text-muted mb-4" style={{ fontSize: '13px' }}>
                                            This file type (<strong>.{fileExtension}</strong>) cannot be previewed directly.<br />
                                            Please download the file to view it.
                                        </p>
                                        <a
                                            href={fullDocumentUrl}
                                            download
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-primary"
                                        >
                                            ⬇ Download File
                                        </a>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <FaFilePdf size={40} className="text-danger mb-3" />
                                <h5>Document Not Available</h5>
                                <p className="text-muted">The uploaded quotation document could not be loaded.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };
    const handleDocumentView = () => {
        if (uploadedFileUrl) {
            window.open(uploadedFileUrl, '_blank');
        }
    };
    const [editableDeploymentAmount, setEditableDeploymentAmount] = useState(0);



    // ✅ Product categorization (same as renderStep4)
    const getLicenseProducts = () => {
        const licenseProducts = selectedProducts.filter(product => {
            try {
                const productData = product.pricings || product;
                const isLicenseType =
                    productData.categories?.some(cat =>
                        cat.licence_type?.toLowerCase() === 'license'
                    ) ||
                    productData.licence_type?.toLowerCase() === 'license' ||
                    product.revenue_type === 'perpetual' ||
                    (!productData.categories && !productData.licence_type);
                return isLicenseType;
            } catch (error) {
                console.error('Error checking product type:', error, product);
                return true;
            }
        });
        return licenseProducts;
    };

    const getDefaultServices = () => {
        if (!formData || formData.model_type !== "new") {
            return [];
        }

        return products.filter(product => {
            const isServiceLicenseType = product.license_type?.toLowerCase() === "service";
            return isServiceLicenseType;
        });
    };

    const defaultServices = getDefaultServices();

    // const calculateDeploymentConfigurationAmount = () => {
    //     if (formData.model_type !== "new") return 0;

    //     const selectedLicenseTypeId = formData.license_type_id;

    //     // Find selected license model name (like "subscription", "perpetual", etc.)
    //     const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
    //         (c) => String(c.id) === String(selectedLicenseTypeId)
    //     );
    //     const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

    //     // Loop over all default service-type products
    //     const amount = defaultServices.reduce((total, service) => {
    //         // Only count service products
    //         if (service.license_type?.toLowerCase() !== "service") return total;

    //         let price = 0;

    //         // ✅ Match pricing array based on license model
    //         if (Array.isArray(service.pricings) && service.pricings.length > 0) {
    //             const matchingPricing = service.pricings.find(
    //                 (p) => p.license_model?.toLowerCase() === selectedLicenseModel
    //             );

    //             if (matchingPricing) {
    //                 price = Number(matchingPricing.price || matchingPricing.amount || 0);
    //             } else {
    //                 // ✅ fallback: if no matching license_model found, take 0
    //                 price = 0;
    //             }
    //         }

    //         return total + price;
    //     }, 0);

    //     return parseFloat(amount);
    // };

    const calculateDeploymentConfigurationAmount = () => {
        if (!formData || formData.model_type !== "new") return 0;

        const selectedLicenseTypeId = formData.license_type_id;
        const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseTypeId)
        );
        const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

        const amount = defaultServices.reduce((total, service) => {
            if (service.license_type?.toLowerCase() !== "service") return total;

            let price = 0;

            if (Array.isArray(service.pricings) && service.pricings.length > 0) {
                const matchingPricing = service.pricings.find(
                    (p) => p.license_model?.toLowerCase() === selectedLicenseModel
                );

                if (matchingPricing) {
                    price = Number(matchingPricing.price || matchingPricing.amount || 0);
                }
            }

            // Convert to client currency
            const serviceCurrency = service.currency || 'AED';
            const convertedAmount = convertPrice(price, serviceCurrency);

            console.log(`🔧 Service ${service.product_name}:`, {
                originalPrice: price,
                serviceCurrency,
                convertedAmount,
                clientCurrency
            });

            return total + convertedAmount;
        }, 0);

        console.log('Total Deployment Configuration Amount:', amount);
        return amount;
    };
    useEffect(() => {
        if (formData.model_type === "new" && defaultServices.length > 0) {
            setEditableDeploymentAmount(prev => {
                if (prev === 0 || prev === "" || isNaN(prev)) {
                    return calculateDeploymentConfigurationAmount();
                }
                return prev; // keep user-edited value
            });
        }
    }, [defaultServices, formData.model_type]);

    // const getProductDeploymentCost = (productItem) => {
    //     const selectedLicenseName =
    //         formData?.license_type_name?.toLowerCase?.() ||
    //         categories?.allCategoriesList?.find(
    //             (c) => String(c.id) === String(formData?.license_type_id)
    //         )?.name?.toLowerCase?.() ||
    //         null;

    //     // Safely access nested product.pricings
    //     const pricings = productItem?.product?.pricings || [];

    //     if (!Array.isArray(pricings) || pricings.length === 0) {
    //         return parseFloat(productItem?.product?.deployment_cost || 0);
    //     }

    //     const matchedPricing =
    //         pricings.find(
    //             (p) => p.license_model?.toLowerCase() === selectedLicenseName
    //         ) ||
    //         pricings.find((p) => parseFloat(p.deployment_cost) > 0) ||
    //         pricings[0];

    //     console.log("🧩 Matched pricing for", productItem.item_name, matchedPricing);

    //     return parseFloat(matchedPricing?.deployment_cost || 0);
    // };

    const convertPrice = (price, productCurrency = 'AED') => {
        if (price === undefined || price === null) return 0;
        const priceNumber = parseFloat(price);
        if (isNaN(priceNumber)) return 0;

        console.log('🔄 convertPrice in Preview:', {
            originalPrice: priceNumber,
            productCurrency,
            clientCurrency,
            conversionNeeded: productCurrency !== clientCurrency
        });

        // If currencies match, no conversion needed
        if (productCurrency === clientCurrency) {
            console.log('✅ No conversion needed - same currency');
            return priceNumber;
        }

        // Handle conversion scenarios
        if (productCurrency === 'AED' && clientCurrency === 'USD') {
            const converted = priceNumber / usdToAedExchangeRate;
            console.log('💱 AED to USD:', { original: priceNumber, converted });
            return converted;
        } else if (productCurrency === 'USD' && clientCurrency === 'AED') {
            const converted = priceNumber * usdToAedExchangeRate;
            console.log('💱 USD to AED:', { original: priceNumber, converted });
            return converted;
        }

        console.warn('⚠️ No conversion rule for:', { productCurrency, clientCurrency });
        return priceNumber;
    };
    const getProductDeploymentCost = (productItem) => {
        const selectedLicenseName =
            formData?.license_type_name?.toLowerCase?.() ||
            categories?.allCategoriesList?.find(
                (c) => String(c.id) === String(formData?.license_type_id)
            )?.name?.toLowerCase?.() ||
            null;

        // Safely access nested product.pricings
        const pricings = productItem?.product?.pricings || [];

        if (!Array.isArray(pricings) || pricings.length === 0) {
            const rawCost = parseFloat(productItem?.product?.deployment_cost || 0);
            const productCurrency = productItem?.product?.currency || 'AED';
            return convertPrice(rawCost, productCurrency);
        }

        const matchedPricing =
            pricings.find(
                (p) => p.license_model?.toLowerCase() === selectedLicenseName
            ) ||
            pricings.find((p) => parseFloat(p.deployment_cost) > 0) ||
            pricings[0];

        console.log("🧩 Matched pricing for", productItem.item_name, matchedPricing);

        const rawCost = parseFloat(matchedPricing?.deployment_cost || 0);
        const productCurrency = productItem?.product?.currency || 'AED';

        return convertPrice(rawCost, productCurrency);
    };
    const getProductDeploymentDescription = (productItem) => {
        const selectedLicenseId = formData?.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        // Access nested product.pricings
        const pricings = productItem?.product?.pricings || [];

        // Debug check
        console.log("🧠 Selected license:", selectedLicenseName);
        console.log("🧩 Available pricings:", pricings);

        if (!Array.isArray(pricings) || pricings.length === 0) {
            return `${productItem.item_name} Setup`;
        }

        const matchedPricing = selectedLicenseName
            ? pricings.find(
                (p) => p.license_model?.toLowerCase?.() === selectedLicenseName
            )
            : pricings[0];

        return (
            matchedPricing?.deployment_description ||
            `${productItem.item_name} Deployment & Configuration`
        );
    };

    // ✅ Calculate One Time Total (sum of all product deployment costs)
    // const calculateOneTimeTotal = () => {
    //     return selectedProducts.reduce((total, product) => {
    //         const deploymentCost = getProductDeploymentCost(product);
    //         return total + deploymentCost;
    //     }, 0);
    // };

    const calculateOneTimeTotal = () => {
        return selectedProducts.reduce((total, product) => {
            const deploymentCost = getProductDeploymentCost(product);
            console.log(`💰 Deployment cost for ${product.item_name}:`, {
                rawCost: product?.product?.deployment_cost,
                productCurrency: product?.product?.currency,
                convertedCost: deploymentCost,
                clientCurrency
            });
            return total + deploymentCost;
        }, 0);
    };

    // ✅ Get all deployment items (EXACTLY like renderStep4)
    const getAllDeploymentItems = () => {
        const items = [];

        // Add individual product deployments FROM PRICING DATA
        selectedProducts.forEach(product => {
            const deploymentCost = getProductDeploymentCost(product);
            console.log(`🔍 Product ${product.product_id}:`, {
                productId: product.product_id,
                deploymentCost: deploymentCost,
                hasDescription: editableDeploymentDescriptions[product.product_id],
                description: editableDeploymentDescriptions[product.product_id]
            });

            if (deploymentCost > 0) {
                const description = editableDeploymentDescriptions[product.product_id] ||
                    product.deployment_description ||
                    getProductDeploymentDescription(product) ||
                    `${product.item_name} Deployment & Configuration`;

                console.log(`🔍 Final description for ${product.product_id}:`, description);
                items.push(description);
            }
        });

        // Add custom integration items
        if (customIntegrationDescription) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = customIntegrationDescription;

            const listItems = tempDiv.querySelectorAll('li, p, div');

            if (listItems.length > 0) {
                listItems.forEach(item => {
                    const text = item.textContent?.trim();
                    if (text && text.length > 0) {
                        items.push(text);
                    }
                });
            } else {
                const lines = customIntegrationDescription.split(/<br\s*\/?>|<\/p>|<\/div>|\n|\•|\-/);
                lines.forEach(line => {
                    const text = line.replace(/<[^>]*>/g, '').trim();
                    if (text && text.length > 0) {
                        items.push(text);
                    }
                });
            }
        }

        return items;
    };

    const usdToAedExchangeRate = 3.67;

    // ✅ Calculate totals (EXACTLY like renderStep4)
    const calculateLicenseDiscount = (totalLicenseCost) => {
        const { license_discount_type = 'amount', license_discount_amount } = formData;
        if (!license_discount_amount) return 0;

        const discountType = license_discount_type || 'amount';
        return discountType === 'amount'
            ? parseFloat(license_discount_amount)
            : (license_discount_amount / 100) * totalLicenseCost;
    };

    const calculateServiceDiscount = (totalOneTimeCost) => {
        const { service_discount_type = 'amount', service_discount_amount } = formData;
        if (!service_discount_amount) return 0;

        const discountType = service_discount_type || 'amount';
        return discountType === 'amount'
            ? parseFloat(service_discount_amount)
            : (service_discount_amount / 100) * totalOneTimeCost;
    };

    const calculateOverallDiscount = (subtotal) => {
        const { discount_type = 'amount', discount_amount } = formData;
        if (!discount_amount) return 0;

        const discountType = discount_type || 'amount';
        return discountType === 'amount'
            ? parseFloat(discount_amount)
            : (discount_amount / 100) * subtotal;
    };

    const calculateTotals = () => {
        const licenseProducts = getLicenseProducts();

        const licenseTotal = licenseProducts.reduce((total, product) =>
            total + parseFloat(product.subtotal || 0), 0
        );

        const oneTimeTotal = calculateOneTimeTotal();
        // const convertedIndividualDeploymentAmount = clientCurrency === 'USD'
        //     ? oneTimeTotal / usdToAedExchangeRate
        //     : oneTimeTotal;
        const convertedIndividualDeploymentAmount = oneTimeTotal;
        const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);
        const subscriptionPeriod = parseInt(formData?.subscription_period || 12);

        const selectedLicenseId = formData?.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        let totalLicenseCost = licenseTotal;
        if (selectedLicenseName === 'subscription') {
            totalLicenseCost = licenseTotal * subscriptionPeriod;
        }

        // ✅ CRITICAL: Same calculation as renderStep4
        const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;
        // const subtotal = totalLicenseCost + totalOneTimeCost;

        // // Calculate discount
        // let discountAmount = 0;
        // if (formData?.discount_amount > 0) {
        //     if (formData.discount_type === 'percentage') {
        //         discountAmount = (parseFloat(formData.discount_amount) / 100) * subtotal;
        //     } else {
        //         discountAmount = parseFloat(formData.discount_amount);
        //     }
        // }

        // const grandTotal = subtotal - discountAmount;
        const licenseDiscountValue = calculateLicenseDiscount(totalLicenseCost);
        const serviceDiscountValue = calculateServiceDiscount(totalOneTimeCost);

        // ✅ Calculate after individual discounts
        const licenseAfterDiscount = totalLicenseCost - licenseDiscountValue;
        const serviceAfterDiscount = totalOneTimeCost - serviceDiscountValue;

        // ✅ Subtotal after individual discounts
        const subtotalAfterIndividualDiscounts = licenseAfterDiscount + serviceAfterDiscount;

        // ✅ Calculate overall discount
        const overallDiscountValue = calculateOverallDiscount(subtotalAfterIndividualDiscounts);

        // ✅ Final grand total
        const grandTotal = subtotalAfterIndividualDiscounts - overallDiscountValue;

        return {
            licenseProducts,
            licenseTotal,
            oneTimeTotal,
            editableDeploymentAmount,
            convertedIndividualDeploymentAmount,
            customIntegrationTotal: customIntegrationTotalValue,
            subscriptionPeriod,
            selectedLicenseName,
            totalLicenseCost,
            totalOneTimeCost,
            // subtotal,
            // discountAmount,
            licenseDiscountValue,
            serviceDiscountValue,
            licenseAfterDiscount,
            serviceAfterDiscount,
            subtotalAfterIndividualDiscounts,
            overallDiscountValue,
            grandTotal
        };
    };

    const totals = calculateTotals();
    const allDeploymentItems = getAllDeploymentItems();
    const selectedBrand = brands?.find(b => b.id === Number(formData?.brand_id))?.name || "Brand";
    const licenseDiscountType = formData?.license_discount_type || 'amount';
    const serviceDiscountType = formData?.service_discount_type || 'amount';
    const overallDiscountType = formData?.discount_type || 'amount';

    const renderSystemGeneratedPreview = () => {
        return (
            <div style={{
                padding: '20px',
                backgroundColor: 'white',
                minHeight: '100%',
                maxWidth: '210mm',
                margin: '0 auto',
                fontSize: '12px'
            }}>
                {/* NEW HEADER - Matching HTML Template */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'relative',
                    marginBottom: '10px'
                }}>
                    {/* Left Section - Company Details */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '6px'
                        }}>
                            {companyDetails?.company_name || 'SYSTECH TECHNOLOGIES'}
                        </div>
                        <div style={{
                            fontSize: '12px',
                            lineHeight: '1.5'
                        }}>
                            {companyDetails?.company_address ? (
                                <div dangerouslySetInnerHTML={{
                                    __html: companyDetails.company_address
                                }} />
                            ) : (
                                <>
                                    Dirt All Nokia Building, Office 307<br />
                                    P.O Box 91507
                                </>
                            )}
                            <br />
                            Phone: {companyDetails?.phone || 'N/A'}<br />
                            Email: {companyDetails?.email || 'N/A'}
                        </div>
                    </div>

                    {/* Right Section - Logo and Quotation Title */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        position: 'absolute',
                        right: '0',
                        top: '0'
                    }}>
                        {/* Logo */}
                        <div style={{
                            width: '180px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            {companyDetails?.logo ? (
                                <img
                                    src={`${backendUrl}/storage/${companyDetails.logo}`}
                                    alt="Company Logo"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain'
                                    }}
                                />
                            ) : (
                                <span style={{ color: '#666', fontSize: '11px' }}>Company Logo</span>
                            )}
                        </div>
                        <div style={{
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: 'black',
                        }}>
                            QUOTATION
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div style={{
                    borderTop: '1px solid #ddd',
                    margin: '10px 0 20px 0'
                }}></div>

                {/* Quotation Details */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '20px',
                    width: '100%'
                }}>
                    {/* Left Column - Project Info */}
                    <div style={{
                        float: 'left',
                        width: '48%',
                        boxSizing: 'border-box'
                    }}>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Project</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>{projectName || 'INSP-WPP'}</span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Document No</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>{formData?.ref_no || 'Q25-AE/01/2049'}</span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Date</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>{formData?.date || '01 Jul 2025'}</span>
                        </div>
                    </div>

                    {/* Right Column - Customer Info */}
                    <div style={{
                        float: 'right',
                        width: '48%',
                        boxSizing: 'border-box'
                    }}>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Customer:</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>{clientName || 'Customer Name'}</span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Address:</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>
                                {clientName ? `${clientName} Address` : 'Customer Address'}
                            </span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Email:</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>
                                {clientName ? `${clientName.toLowerCase().replace(' ', '')}@example.com` : 'customer@example.com'}
                            </span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '100px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                                whiteSpace: 'nowrap'
                            }}>Phone:</span>
                            <span style={{
                                display: 'inline-block',
                                marginLeft: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                lineHeight: '1.5',
                                maxWidth: 'calc(100% - 180px)',
                                verticalAlign: 'top'
                            }}>
                                {clientName ? '+971-XXXXXXX' : '+971-66838999'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* ============================= LICENSE SECTION ============================= */}
                {totals.licenseProducts.length > 0 && (
                    <div className="mb-4 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
                            {selectedBrand} - Licenses
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ width: "20%", fontSize: "12px", fontWeight: "bold" }}>License</th>
                                        <th style={{ width: "40%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
                                        <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Qty</th>
                                        <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Rate</th>
                                        <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {totals.licenseProducts.map((product, index) => (
                                        <tr key={index}>
                                            <td style={{ fontSize: "12px" }}>
                                                {product.item_name}
                                            </td>
                                            <td style={{ fontSize: "12px" }} className="text-start">{product.item_description || '-'}</td>
                                            <td style={{ fontSize: "12px" }} className="text-center">{product.quantity || 1}</td>
                                            <td style={{ fontSize: "12px" }} className="text-center">
                                                {safeToFixed(product.price)}
                                            </td>
                                            <td style={{ fontSize: "12px" }} className="text-end">
                                                {safeToFixed(product.subtotal)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            Total License Cost {totals.selectedLicenseName === 'subscription' ? 'per month' : ''}
                                        </td>
                                        <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            {safeToFixed(totals.licenseTotal)}
                                        </td>
                                    </tr>
                                    {totals.selectedLicenseName === 'subscription' && (
                                        <tr>
                                            <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                Total License Cost per {totals.subscriptionPeriod} months
                                            </td>
                                            <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                {safeToFixed(totals.totalLicenseCost)}
                                            </td>
                                        </tr>
                                    )}
                                    {totals.licenseDiscountValue > 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
                                                License Discount ({licenseDiscountType === 'amount' ? clientCurrency : '%'})
                                            </td>
                                            <td className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
                                                -{safeToFixed(totals.licenseDiscountValue)}
                                            </td>
                                        </tr>
                                    )}

                                    {totals.licenseDiscountValue > 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
                                                License After Discount
                                            </td>
                                            <td className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
                                                {safeToFixed(totals.licenseAfterDiscount)}
                                            </td>
                                        </tr>
                                    )}
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}

                {/* ============================= ONE-TIME & INTEGRATION SECTION ============================= */}
                {(totals.editableDeploymentAmount > 0 || (totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal) > 0) && (
                    <div className="mb-4 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
                            {selectedBrand} - Onboarding & Custom Integration
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ width: "65%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
                                        <th style={{ width: "5%", fontSize: "12px", fontWeight: "bold" }}>QTY</th>
                                        <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Rate</th>
                                        <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* ✅ One Time deployment, Configuration & Testing - Separate Row */}
                                    {totals.editableDeploymentAmount > 0 && (
                                        <tr>
                                            <td style={{ fontSize: "13px" }} className='text-start'>
                                                One Time deployment, Configuration & Testing
                                            </td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>1</td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>
                                                {safeToFixed(totals.editableDeploymentAmount)}
                                            </td>
                                            <td className="text-end" style={{ fontSize: "12px" }}>
                                                {safeToFixed(totals.editableDeploymentAmount)}
                                            </td>
                                        </tr>
                                    )}

                                    {/* ✅ Custom Integration with Ordered List */}
                                    {(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal) > 0 && (
                                        <tr>
                                            <td className="text-start" style={{ fontSize: "13px" }}>
                                                <div className="fw-medium">Custom Integration</div>
                                                {allDeploymentItems.length > 0 && (
                                                    <div className="mt-2">
                                                        <ol className="mb-0" style={{ fontSize: "12px", paddingLeft: "20px" }}>
                                                            {allDeploymentItems.map((item, index) => (
                                                                <li key={index} className="text-muted">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ol>
                                                    </div>
                                                )}
                                            </td>
                                            <td className='text-center' style={{ fontSize: "12px" }}>1</td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>
                                                {safeToFixed(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal)}
                                            </td>
                                            <td className="text-end" style={{ fontSize: "12px" }}>
                                                {safeToFixed(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal)}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="3" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            Total One-time Cost ({clientCurrency})
                                        </td>
                                        <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            {safeToFixed(totals.totalOneTimeCost)}
                                        </td>
                                    </tr>
                                    {totals.serviceDiscountValue > 0 && (
                                        <tr>
                                            <td colSpan="3" className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
                                                Service Discount ({serviceDiscountType === 'amount' ? clientCurrency : '%'})
                                            </td>
                                            <td className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
                                                -{safeToFixed(totals.serviceDiscountValue)}
                                            </td>
                                        </tr>
                                    )}

                                    {/* ✅ SERVICE AFTER DISCOUNT */}
                                    {totals.serviceDiscountValue > 0 && (
                                        <tr>
                                            <td colSpan="3" className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
                                                Services After Discount
                                            </td>
                                            <td className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
                                                {safeToFixed(totals.serviceAfterDiscount)}
                                            </td>
                                        </tr>
                                    )}
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
                <div className="mb-4 border rounded">
                    <div className="py-2 px-3 text-dark fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
                        Final Summary
                    </div>
                    <div className="p-3">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Subtotal after individual discounts */}
                                <div className="d-flex justify-content-between mb-2" style={{ fontSize: "13px" }}>
                                    <span className="fw-medium">Subtotal:</span>
                                    <span className="fw-medium">{safeToFixed(totals.subtotalAfterIndividualDiscounts)} {clientCurrency}</span>
                                </div>

                                {/* Overall Discount */}
                                {totals.overallDiscountValue > 0 && (
                                    <div className="d-flex justify-content-between mb-2 text-dark" style={{ fontSize: "13px" }}>
                                        <span className="fw-medium">Overall Discount ({overallDiscountType === 'amount' ? clientCurrency : '%'}):</span>
                                        <span className="fw-medium">-{safeToFixed(totals.overallDiscountValue)} {clientCurrency}</span>
                                    </div>
                                )}

                                {/* Grand Total */}
                                <div className="d-flex justify-content-between fw-bold pt-2 border-top" style={{ fontSize: "14px" }}>
                                    <span>Grand Total:</span>
                                    <span className="text-dark">{safeToFixed(totals.grandTotal)} {clientCurrency}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Terms & Conditions */}
                {formData?.notes && (
                    <div className="mt-4 pt-3 border-top">
                        <h6 className="fw-bold border-bottom pb-2">Terms & Conditions</h6>
                        <div
                            style={{ fontSize: "12px" }}
                            dangerouslySetInnerHTML={{ __html: formData.notes }}
                        />
                    </div>
                )}
            </div>
        );
    };


    return (
        <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '1050px' }} className="quotation-preview-offcanvas">
            <Offcanvas.Header closeButton className="border-bottom bg-light position-relative">
                <Offcanvas.Title className="fw-semibold">
                    <i className="fa fa-file-pdf text-danger me-2"></i>
                    Quotation Preview - {formData?.ref_no}

                </Offcanvas.Title>

                {/* Edit and Download buttons at top right with spacing */}
                <div className="position-absolute top-0 end-0 p-3 d-flex gap-2 me-4">
                    {/* Edit button - only show for system-generated quotations */}
                    {!isUploaded && onEdit && (
                        <Button
                            variant="light"
                            onClick={onEdit}
                            size="sm"
                            className="shadow-sm"
                            title="Edit Quotation"
                        >
                            <FaEdit className="me-1" />
                            Edit
                        </Button>
                    )}

                    {/* Download button - different behavior for uploaded vs system */}
                    <Button
                        variant="light"
                        onClick={isUploaded ? handleDocumentDownload : onDownload}
                        size="sm"
                        className="shadow-sm"
                        title={isUploaded ? "Download Document" : "Download PDF"}
                    >
                        <FaDownload className="me-1" />
                        {isUploaded ? 'Download' : 'PDF'}
                    </Button>



                </div>
            </Offcanvas.Header>

            <Offcanvas.Body style={{
                padding: '0',
                backgroundColor: '#f8f9fa',
                overflowY: 'auto',
                overflowX: 'hidden'
            }}>
                {isUploaded ? renderUploadedDocumentPreview() : renderSystemGeneratedPreview()}
            </Offcanvas.Body>
        </Offcanvas>
    );


    //     return (
    //         <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '1050px' }} className="quotation-preview-offcanvas">
    //          <Offcanvas.Header closeButton className="border-bottom bg-light position-relative">
    //     <Offcanvas.Title className="fw-semibold">
    //         <i className="fa fa-file-pdf text-danger me-2"></i>
    //         Quotation Preview - {formData?.ref_no}
    //     </Offcanvas.Title>

    //     {/* Edit and Download buttons at top right with spacing */}
    //     <div className="position-absolute top-0 end-0 p-3 d-flex gap-2 me-4">
    //         <Button
    //             variant="light"
    //             onClick={onEdit}
    //             size="sm"
    //             className="shadow-sm"
    //             title="Edit Quotation"
    //         >
    //             <i className="fa fa-edit"></i>
    //         </Button>
    //         <Button
    //             variant="light"
    //             onClick={onDownload}
    //             size="sm"
    //             className="shadow-sm"
    //             title="Download PDF"
    //         >
    //             <i className="fa fa-download"></i>
    //         </Button>
    //     </div>
    // </Offcanvas.Header>

    //             <Offcanvas.Body style={{
    //                 padding: '0',
    //                 backgroundColor: '#f8f9fa'
    //             }}>
    //                 {/* PDF Style Preview */}
    //                 <div style={{
    //                     padding: '20px',
    //                     backgroundColor: 'white',
    //                     minHeight: '100%',
    //                     width: '250mm',
    //                     margin: '0 auto',
    //                     fontSize: '12px'
    //                 }}>
    //                     {/* NEW HEADER - Matching HTML Template */}
    //                     <div style={{ 
    //                         display: 'flex', 
    //                         justifyContent: 'space-between', 
    //                         position: 'relative',
    //                         marginBottom: '10px'
    //                     }}>
    //                         {/* Left Section - Company Details */}
    //                         <div style={{ display: 'flex', flexDirection: 'column' }}>
    //                             <div style={{ 
    //                                 fontSize: '18px', 
    //                                 fontWeight: 'bold', 
    //                                 marginBottom: '6px' 
    //                             }}>
    //                                 {companyDetails?.company_name || 'SYSTECH TECHNOLOGIES'}
    //                             </div>
    //                             <div style={{ 
    //                                 fontSize: '12px', 
    //                                 lineHeight: '1.5' 
    //                             }}>
    //                                 {companyDetails?.company_address ? (
    //                                     <div dangerouslySetInnerHTML={{ 
    //                                         __html: companyDetails.company_address 
    //                                     }} />
    //                                 ) : (
    //                                     <>
    //                                         Dirt All Nokia Building, Office 307<br />
    //                                         P.O Box 91507
    //                                     </>
    //                                 )}
    //                                 <br />
    //                                 Phone: {companyDetails?.phone || 'N/A'}<br />
    //                                 Email: {companyDetails?.email || 'N/A'}
    //                             </div>
    //                         </div>

    //                         {/* Right Section - Logo and Quotation Title */}
    //                         <div style={{ 
    //                             display: 'flex', 
    //                             flexDirection: 'column', 
    //                             alignItems: 'flex-end',
    //                             position: 'absolute',
    //                             right: '0',
    //                             top: '0'
    //                         }}>
    //                             {/* Logo */}
    //                             <div style={{
    //                                 width: '180px',
    //                                 height: '80px',
    //                                 display: 'flex',
    //                                 alignItems: 'center',
    //                                 justifyContent: 'center',
    //                             }}>
    //                                 {companyDetails?.logo ? (
    //                                     <img 
    //                                         src={`${backendUrl}/storage/${companyDetails.logo}`} 
    //                                         alt="Company Logo" 
    //                                         style={{ 
    //                                             maxWidth: '100%', 
    //                                             maxHeight: '100%',
    //                                             objectFit: 'contain' 
    //                                         }}
    //                                     />
    //                                 ) : (
    //                                     <span style={{ color: '#666', fontSize: '11px' }}>Company Logo</span>
    //                                 )}
    //                             </div>
    //                             <div style={{ 
    //                                 fontSize: '24px', 
    //                                 fontWeight: 'bold', 
    //                                 color: 'black',
    //                             }}>
    //                                 QUOTATION
    //                             </div>
    //                         </div>
    //                     </div>

    //                     {/* Divider */}
    //                     <div style={{ 
    //                         borderTop: '1px solid #ddd', 
    //                         margin: '10px 0 20px 0' 
    //                     }}></div>

    //                     {/* Quotation Details */}
    //                     <div style={{ 
    //                         display: 'flex', 
    //                         justifyContent: 'space-between', 
    //                         marginBottom: '20px',
    //                         width: '100%'
    //                     }}>
    //                         {/* Left Column - Project Info */}
    //                         <div style={{ 
    //                             float: 'left', 
    //                             width: '48%', 
    //                             boxSizing: 'border-box' 
    //                         }}>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Project</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>{projectName || 'INSP-WPP'}</span>
    //                             </div>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Document No</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>{formData?.ref_no || 'Q25-AE/01/2049'}</span>
    //                             </div>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Date</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>{formData?.date || '01 Jul 2025'}</span>
    //                             </div>
    //                         </div>

    //                         {/* Right Column - Customer Info */}
    //                         <div style={{ 
    //                             float: 'right', 
    //                             width: '48%', 
    //                             boxSizing: 'border-box' 
    //                         }}>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Customer:</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>{clientName || 'Customer Name'}</span>
    //                             </div>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Address:</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>
    //                                     {clientName ? `${clientName} Address` : 'Customer Address'}
    //                                 </span>
    //                             </div>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Email:</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>
    //                                     {clientName ? `${clientName.toLowerCase().replace(' ', '')}@example.com` : 'customer@example.com'}
    //                                 </span>
    //                             </div>
    //                             <div style={{ marginBottom: '8px' }}>
    //                                 <span style={{ 
    //                                     display: 'inline-block', 
    //                                     width: '100px', 
    //                                     fontWeight: 'bold',
    //                                     verticalAlign: 'top',
    //                                     whiteSpace: 'nowrap'
    //                                 }}>Phone:</span>
    //                                 <span style={{ 
    //                                     display: 'inline-block',
    //                                     marginLeft: '8px',
    //                                     wordBreak: 'break-word',
    //                                     whiteSpace: 'normal',
    //                                     lineHeight: '1.5',
    //                                     maxWidth: 'calc(100% - 180px)',
    //                                     verticalAlign: 'top'
    //                                 }}>
    //                                     {clientName ? '+971-XXXXXXX' : '+971-66838999'}
    //                                 </span>
    //                             </div>
    //                         </div>
    //                     </div>

    //                     {/* ============================= LICENSE SECTION ============================= */}
    //                     {totals.licenseProducts.length > 0 && (
    //                         <div className="mb-4 border rounded">
    //                             <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
    //                                 {selectedBrand} - Licenses
    //                             </div>

    //                             <div className="table-responsive">
    //                                 <table className="table table-bordered mb-0 align-middle">
    //                                     <thead>
    //                                         <tr>
    //                                             <th style={{ width: "20%", fontSize: "12px", fontWeight: "bold" }}>License</th>
    //                                             <th style={{ width: "40%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
    //                                             <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Qty</th>
    //                                             <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Rate</th>
    //                                             <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Amount</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         {totals.licenseProducts.map((product, index) => (
    //                                             <tr key={index}>
    //                                                 <td style={{ fontSize: "12px" }}>
    //                                                     {product.item_name}
    //                                                 </td>
    //                                                 <td style={{ fontSize: "12px" }} className="text-start">{product.item_description || '-'}</td>
    //                                                 <td style={{ fontSize: "12px" }} className="text-center">{product.quantity || 1}</td>
    //                                                 <td style={{ fontSize: "12px" }} className="text-center">
    //                                                     {safeToFixed(product.price)}
    //                                                 </td>
    //                                                 <td style={{ fontSize: "12px" }} className="text-end">
    //                                                     {safeToFixed(product.subtotal)}
    //                                                 </td>
    //                                             </tr>
    //                                         ))}
    //                                     </tbody>
    //                                     <tfoot>
    //                                         <tr>
    //                                             <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
    //                                                 Total License Cost {totals.selectedLicenseName === 'subscription' ? 'per month' : ''}
    //                                             </td>
    //                                             <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
    //                                                 {safeToFixed(totals.licenseTotal)}
    //                                             </td>
    //                                         </tr>
    //                                         {totals.selectedLicenseName === 'subscription' && (
    //                                             <tr>
    //                                                 <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
    //                                                     Total License Cost per {totals.subscriptionPeriod} months
    //                                                 </td>
    //                                                 <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
    //                                                     {safeToFixed(totals.totalLicenseCost)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}
    //                                          {totals.licenseDiscountValue > 0 && (
    //                                             <tr>
    //                                                 <td colSpan="4" className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
    //                                                     License Discount ({licenseDiscountType === 'amount' ? clientCurrency : '%'})
    //                                                 </td>
    //                                                 <td className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
    //                                                     -{safeToFixed(totals.licenseDiscountValue)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}

    //                                         {totals.licenseDiscountValue > 0 && (
    //                                             <tr>
    //                                                 <td colSpan="4" className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
    //                                                     License After Discount
    //                                                 </td>
    //                                                 <td className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
    //                                                     {safeToFixed(totals.licenseAfterDiscount)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}
    //                                     </tfoot>
    //                                 </table>
    //                             </div>
    //                         </div>
    //                     )}

    //                     {/* ============================= ONE-TIME & INTEGRATION SECTION ============================= */}
    //                     {( totals.editableDeploymentAmount > 0 || (totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal) > 0) && (
    //                         <div className="mb-4 border rounded">
    //                             <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
    //                                 {selectedBrand} - Onboarding & Custom Integration
    //                             </div>

    //                             <div className="table-responsive">
    //                                 <table className="table table-bordered mb-0 align-middle">
    //                                     <thead>
    //                                         <tr>
    //                                             <th style={{ width: "65%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
    //                                             <th style={{ width: "5%", fontSize: "12px", fontWeight: "bold" }}>QTY</th>
    //                                             <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Rate</th>
    //                                             <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Amount</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         {/* ✅ One Time deployment, Configuration & Testing - Separate Row */}
    //                                         {totals.editableDeploymentAmount > 0 && (
    //                                             <tr>
    //                                                 <td style={{ fontSize: "13px" }} className='text-start'>
    //                                                     One Time deployment, Configuration & Testing
    //                                                 </td>
    //                                                 <td className="text-center" style={{ fontSize: "12px" }}>1</td>
    //                                                 <td className="text-center" style={{ fontSize: "12px" }}>
    //                                                     {safeToFixed(totals.editableDeploymentAmount)}
    //                                                 </td>
    //                                                 <td className="text-end" style={{ fontSize: "12px" }}>
    //                                                     {safeToFixed(totals.editableDeploymentAmount)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}

    //                                         {/* ✅ Custom Integration with Ordered List */}
    //                                         {(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal) > 0 && (
    //                                             <tr>
    //                                                 <td className="text-start" style={{ fontSize: "13px" }}>
    //                                                     <div className="fw-medium">Custom Integration</div>
    //                                                     {allDeploymentItems.length > 0 && (
    //                                                         <div className="mt-2">
    //                                                             <ol className="mb-0" style={{ fontSize: "12px", paddingLeft: "20px" }}>
    //                                                                 {allDeploymentItems.map((item, index) => (
    //                                                                     <li key={index} className="text-muted">
    //                                                                         {item}
    //                                                                     </li>
    //                                                                 ))}
    //                                                             </ol>
    //                                                         </div>
    //                                                     )}
    //                                                 </td>
    //                                                 <td className='text-center' style={{ fontSize: "12px" }}>1</td>
    //                                                 <td className="text-center" style={{ fontSize: "12px" }}>
    //                                                     {safeToFixed(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal)}
    //                                                 </td>
    //                                                 <td className="text-end" style={{ fontSize: "12px" }}>
    //                                                     {safeToFixed(totals.convertedIndividualDeploymentAmount + totals.customIntegrationTotal)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}
    //                                     </tbody>
    //                                     <tfoot>
    //                                         <tr>
    //                                             <td colSpan="3" className="text-end fw-medium" style={{ fontSize: "13px" }}>
    //                                                 Total One-time Cost ({clientCurrency})
    //                                             </td>
    //                                             <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
    //                                                 {safeToFixed(totals.totalOneTimeCost)}
    //                                             </td>
    //                                         </tr>
    //                                          {totals.serviceDiscountValue > 0 && (
    //                                             <tr>
    //                                                 <td colSpan="3" className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
    //                                                     Service Discount ({serviceDiscountType === 'amount' ? clientCurrency : '%'})
    //                                                 </td>
    //                                                 <td className="text-end fw-medium text-dark" style={{ fontSize: "13px" }}>
    //                                                     -{safeToFixed(totals.serviceDiscountValue)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}

    //                                         {/* ✅ SERVICE AFTER DISCOUNT */}
    //                                         {totals.serviceDiscountValue > 0 && (
    //                                             <tr>
    //                                                 <td colSpan="3" className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
    //                                                     Services After Discount
    //                                                 </td>
    //                                                 <td className="text-end fw-bold text-dark" style={{ fontSize: "13px" }}>
    //                                                     {safeToFixed(totals.serviceAfterDiscount)}
    //                                                 </td>
    //                                             </tr>
    //                                         )}
    //                                     </tfoot>
    //                                 </table>
    //                             </div>
    //                         </div>
    //                     )}
    //                                         <div className="mb-4 border rounded">
    //                         <div className="py-2 px-3 text-dark fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
    //                             Final Summary
    //                         </div>
    //                         <div className="p-3">
    //                             <div className="row">
    //                                 <div className="col-md-12">
    //                                     {/* Subtotal after individual discounts */}
    //                                     <div className="d-flex justify-content-between mb-2" style={{ fontSize: "13px" }}>
    //                                         <span className="fw-medium">Subtotal:</span>
    //                                         <span className="fw-medium">{safeToFixed(totals.subtotalAfterIndividualDiscounts)} {clientCurrency}</span>
    //                                     </div>

    //                                     {/* Overall Discount */}
    //                                     {totals.overallDiscountValue > 0 && (
    //                                         <div className="d-flex justify-content-between mb-2 text-dark" style={{ fontSize: "13px" }}>
    //                                             <span className="fw-medium">Overall Discount ({overallDiscountType === 'amount' ? clientCurrency : '%'}):</span>
    //                                             <span className="fw-medium">-{safeToFixed(totals.overallDiscountValue)} {clientCurrency}</span>
    //                                         </div>
    //                                     )}

    //                                     {/* Grand Total */}
    //                                     <div className="d-flex justify-content-between fw-bold pt-2 border-top" style={{ fontSize: "14px" }}>
    //                                         <span>Grand Total:</span>
    //                                         <span className="text-dark">{safeToFixed(totals.grandTotal)} {clientCurrency}</span>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>

    //                     {/* Terms & Conditions */}
    //                     {formData?.notes && (
    //                         <div className="mt-4 pt-3 border-top">
    //                             <h6 className="fw-bold border-bottom pb-2">Terms & Conditions</h6>
    //                             <div
    //                                 style={{ fontSize: "12px" }}
    //                                 dangerouslySetInnerHTML={{ __html: formData.notes }}
    //                             />
    //                         </div>
    //                     )}
    //                 </div>
    //             </Offcanvas.Body>

    //             {/* Bottom buttons (optional - you can remove these if you only want top buttons) */}
    //             {/* <div className="p-3 border-top bg-light d-flex justify-content-between">
    //                 <Button
    //                     variant="outline-secondary"
    //                     onClick={handleClose}
    //                     size="sm"
    //                 >
    //                     <i className="fa fa-times me-2"></i>
    //                     Close
    //                 </Button>
    //                 <div>
    //                     <Button
    //                         variant="warning"
    //                         onClick={onEdit}
    //                         size="sm"
    //                         className="me-2"
    //                     >
    //                         <i className="fa fa-edit me-2"></i>
    //                         Edit Quotation
    //                     </Button>
    //                     <Button
    //                         variant="primary"
    //                         onClick={onDownload}
    //                         size="sm"
    //                     >
    //                         <i className="fa fa-download me-2"></i>
    //                         Download PDF
    //                     </Button>
    //                 </div>
    //             </div> */}
    //         </Offcanvas>
    //     );
};

export default QuotationPreviewModal;



